// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__AgNLg","left":"Virtual_left__Vra2f","wrapper":"Virtual_wrapper__pmbYH"};